const getSynthesisStepsUrl = (productId: string) => `/products/${productId}/steps`;
const getSynthesisStepUrl = (productId: string, stepId: string) => `/products/${productId}/step/${stepId}`;

export default {
  getSynthesisStepsUrl,
  getSynthesisStepUrl,
};
